/** Textes « menu » — le français fait foi. */
export const menu = {
  secAuComptoir: 'Au comptoir',
  secMesVoitures: 'Mes voitures',
  secMesClients: 'Mes clients',
  secLArgent: "L'argent",
  secMesChiffres: 'Mes chiffres',
  secReglages: 'Réglages',
  aujourdHui: "Aujourd'hui",
  voituresLibres: 'Voitures libres',
  nouvelleLocation: 'Nouvelle location',
  mesLocations: 'Mes locations',
  contrats: 'Contrats',
  planning: 'Planning',
  aValider: 'À valider',
  mesVoitures: 'Mes voitures',
  entretien: 'Entretien',
  vidange: 'Vidange',
  plaquettes: 'Plaquettes',
  pneus: 'Pneus',
  revision: 'Révision',
  courroie: 'Courroie',
  batterie: 'Batterie',
  controleTechnique: 'Contrôle technique',
  assurances: 'Assurances',
  amendes: 'Amendes',
  accidents: 'Accidents',
  clients: 'Clients',
  caisse: 'Caisse',
  dettes: 'Dettes',
  depenses: 'Dépenses',
  caisseExtra: 'Caisse extra',
  banque: 'Banque',
  cautions: 'Cautions',
  factures: 'Factures',
  tresoreriePrevision: 'Trésorerie & prévision',
  analyses: 'Analyses',
  journalDActivite: "Journal d'activité",
  notes: 'Notes',
  guideDuLogiciel: 'Guide du logiciel',
  parametres: 'Paramètres',
  utilisateursEtDroits: 'Utilisateurs et droits',
  supprimerUneFiche: 'Supprimer une fiche',
  mesTaches: 'Mes tâches',
  libres: 'Libres',
  nouvelle: 'Nouvelle',
  plus: 'Plus',
};
